const prefix = '[sidebarHelp] ';

export const SIDEBARHELP_INIT = `${prefix}INIT`;
export const LOAD_HELPFILES = `${prefix}LOAD_INDEX`;
export const LOAD_HELP_ARTICLE = `${prefix}LOAD_HELP`;
export const OPEN_WIDGET = 'HELPWIDGET_OPEN';



// WEBPACK FOOTER //
// ./src/app/components/sidebarHelp/constants.js